import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import BulkBundleCreateForm from "../-form";
import { BulkBundleCrumbs } from "../-crumbs";
import { getGetBulkBundleQueryOptions } from "@/requests/gen/react-query/bulk-bundle";
import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/_practice-360/bulk-bundle/$bulkBundleId/edit",
)({
  loader: ({ context: { queryClient }, params: { bulkBundleId } }) =>
    queryClient.ensureQueryData(
      getGetBulkBundleQueryOptions(numericId(bulkBundleId)),
    ),
  component: BulkBundleEditPage,
});

function BulkBundleEditPage() {
  const { bulkBundleId } = Route.useParams();
  const bulkBundle = useSuspenseQuery(
    suspenseOptions(getGetBulkBundleQueryOptions(numericId(bulkBundleId))),
  );

  return (
    <div>
      <title>
        {`${bulkBundle.data?.name || "Edit Bulk Bundle"} - Legrande Health Portal`}
      </title>
      <BulkBundleCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>Edit Bulk Bundle</CardTitle>
          <CardDescription>Update bundle details below.</CardDescription>
        </CardHeader>
        <CardContent>
          {bulkBundle.data && (
            <BulkBundleCreateForm bulk_bundle={bulkBundle.data} />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
